var App = App || {};

App.WidgetInteractiveComponentSelector = (function ($) {
    'use strict';

    function Init(widget) {
        InitScrollAnimations(widget);
        InitFeaturedMessage(widget);
    }

    function InitScrollAnimations(widget) {
        if (widget.hasClass("disable-animations")) {
            return;
        }

        widget.ZagScrollAnimate({
            offset: 75,
            targets: [
                {
                    selector: ".interactive-component-selector__left > *",
                    type: "animate__fadeInUp",
                    stagger: 150
                }
            ],
            overflow: false
        });
    }

    function InitFeaturedMessage(widget) {
        widget.find(".interactive-featured-message").each(function () {
            var message = $(this);
            var toggle = message.find(".interactive-featured-message__toggle");
            var flip = message.find(".interactive-featured-message__flip");
            var cta = message.find(".interactive-featured-message__cta");

            if (!toggle.length || !flip.length) {
                return;
            }

            function updateState() {
                var isChecked = toggle.is(":checked");

                flip.attr("aria-expanded", isChecked ? "true" : "false");

                if (cta.length) {
                    cta.attr("tabindex", isChecked ? "0" : "-1");
                    cta.attr("aria-hidden", isChecked ? "false" : "true");
                }
            }

            flip.on("click", function (event) {
                event.preventDefault();
                toggle.prop("checked", true).trigger("change");
            });

            toggle.on("change", updateState);
            updateState();
        });
    }

    return {
        Init: Init
    };

}(jQuery));
